module.exports = __webpack_public_path__ + "static/media/mobile-website-back.91cf42ec.png";